import { Navigate } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

import { Page } from '@/design-system-v2/page';

import { pluginsStore } from './plugins.store';

// Leaves for Chats when the plugin's flag turns off while its page is open
export const PluginScreen = observer(({ pluginId }: { pluginId: string }) => {
  const page = pluginsStore.pageOf(pluginId);
  if (!page) return <Navigate to="/chats" replace />;

  const { label, component: Content } = page;
  return (
    <>
      <Page.HeaderTitle>
        <Page.Title>{label}</Page.Title>
      </Page.HeaderTitle>
      {/* Session recordings mask text only under `.no-record`; plugin pages show the user's own data */}
      <div className="no-record contents">
        <Content />
      </div>
    </>
  );
});
